import { createContext } from 'react';
const ScreenTrackingContext = /*#__PURE__*/createContext(undefined);
ScreenTrackingContext.displayName = 'ScreenTrackingContext';
export default ScreenTrackingContext;
export const ScreenTrackingContextProvider = ScreenTrackingContext.Provider;
export const ScreenTrackingContextConsumer = ScreenTrackingContext.Consumer;